const PRINTABLE_CHARACTERS_PATTERN = String.raw`^(?!\u2800|\u3164)[\p{L}\p{N}\p{P}\p{S}]$`
export const PRINTABLE_CHARACTERS_REGEXP = new RegExp(
  PRINTABLE_CHARACTERS_PATTERN,
  'u'
)

// General validation rules: SwRS_19515_S0_I
const ZUGRIFFSCODE_PATTERN = String.raw`^\d*$`
export const ZUGRIFFSCODE_REGEXP = new RegExp(ZUGRIFFSCODE_PATTERN)
export const ZUGRIFFSCODE_NOT_EMPTY_MIN_LENGTH = 1
export const ZUGRIFFSCODE_MIN_LENGTH = 8
export const ZUGRIFFSCODE_MAX_LENGTH = 8

const ZUGNUMMER_PATTERN = String.raw`^\d*$`
export const ZUGNUMMER_REGEXP = new RegExp(ZUGNUMMER_PATTERN)
const ZUGNUMMER_NONZERO_PATTERN = String.raw`^(?!0+$).*$|^$`
export const ZUGNUMMER_NONZERO_REGEXP = new RegExp(ZUGNUMMER_NONZERO_PATTERN)
export const ZUGNUMMER_MIN_LENGTH = 1
export const ZUGNUMMER_MAX_LENGTH = 6

const PATTERN_START = '^['
const PATTERN_END = ']*$'
const FREITEXT_ONELINE_CHARS = String.raw`\u0020-\u003A\u003D\u003F-\u005A\u005E-\u005F\u0061-\u007A\u007E\u00A0-\u00FF\u0100-\u017F`
const FREITEXT_ONELINE_REGEXP = new RegExp(
  PATTERN_START.concat(FREITEXT_ONELINE_CHARS, PATTERN_END)
)

export const BETRIEBSSTELLE_REGEXP = FREITEXT_ONELINE_REGEXP
export const BETRIEBSSTELLE_MIN_LENGTH = 1
export const BETRIEBSSTELLE_MAX_LENGTH = 255

export const DEFAULT_INPUT_REGEXP = FREITEXT_ONELINE_REGEXP
export const DEFAULT_INPUT_MIN_LENGTH = 1
export const DEFAULT_INPUT_MAX_LENGTH = 255

export const SYSTEMNACHRICHT_TITEL_REGEXP = FREITEXT_ONELINE_REGEXP
export const SYSTEMNACHRICHT_TITEL_MIN_LENGTH = 1
export const SYSTEMNACHRICHT_TITEL_MAX_LENGTH = 255

const FREITEXT_MULTILINE_ADDITIONAL_CHARS = String.raw`\u000A\u000D`
const FREITEXT_MULTILINE_REGEXP = new RegExp(
  PATTERN_START.concat(
    FREITEXT_ONELINE_CHARS,
    FREITEXT_MULTILINE_ADDITIONAL_CHARS,
    PATTERN_END
  )
)

export const SYSTEMNACHRICHT_INHALT_REGEXP = FREITEXT_MULTILINE_REGEXP
export const SYSTEMNACHRICHT_INHALT_MIN_LENGTH = 1
export const SYSTEMNACHRICHT_INHALT_MAX_LENGTH = 65535

export const BEANSTANDUNG_REGEXP = FREITEXT_MULTILINE_REGEXP
export const BEANSTANDUNG_MIN_LENGTH = 0
export const BEANSTANDUNG_MAX_LENGTH = 4000

export const BENUTZERSUCHE_REGEXP = FREITEXT_ONELINE_REGEXP
export const BENUTZERSUCHE_MIN_LENGTH = 0
export const BENUTZERSUCHE_MAX_LENGTH = 320

export const MUSTER_AUFTRAG_NAME_REGEXP = FREITEXT_ONELINE_REGEXP
export const MUSTER_AUFTRAG_NAME_MIN_LENGTH = 1
export const MUSTER_AUFTRAG_NAME_MAX_LENGTH = 255

export const NAME_BENUTZER_FILTER_REGEXP = FREITEXT_ONELINE_REGEXP
export const NAME_BENUTZER_FILTER_MIN_LENGTH = 0
export const NAME_BENUTZER_FILTER_MAX_LENGTH = 256

const ARBEITSPLATZ_BEZEICHNUNG_CHARS = String.raw`\u0020-\u002C\u002E-\u007E`
export const ARBEITSPLATZ_BEZEICHNUNG_REGEXP = new RegExp(
  PATTERN_START.concat(ARBEITSPLATZ_BEZEICHNUNG_CHARS, PATTERN_END)
)
export const ARBEITSPLATZ_BEZEICHNUNG_MIN_LENGTH = 1
export const ARBEITSPLATZ_BEZEICHNUNG_MAX_LENGTH = 8

const ARBEITSORT_CHARS = String.raw`\u0020\u0028\u0029\u002D\u0041-\u005A\u0061-\u007A\u00C4\u00D6\u00DC\u00DF\u00E4\u00F6\u00FC`
const ARBEITSORT_PATTERN = PATTERN_START.concat(ARBEITSORT_CHARS, PATTERN_END)
export const ARBEITSORT_REGEXP = new RegExp(ARBEITSORT_PATTERN)
export const ARBEITSORT_MIN_LENGTH = 1
export const ARBEITSORT_MAX_LENGTH = 100

// Befehle input field validation rules: SwRS_20177_S0_I
export const ZUGMELDESTELLE_REGEXP = FREITEXT_ONELINE_REGEXP
export const ZUGMELDESTELLE_MAX_LENGTH = 50

export const ORTSPUNKT_REGEXP = FREITEXT_ONELINE_REGEXP
export const ORTSPUNKT_MAX_LENGTH = 50

const EINDEUTIGE_KENNUNG_PATTERN_END = String.raw`]{1,8}-\d{3,4}-\d{1,6}$`
const EINDEUTIGE_KENNUNG_PATTERN = PATTERN_START.concat(
  ARBEITSPLATZ_BEZEICHNUNG_CHARS,
  String.raw`\u002D`,
  EINDEUTIGE_KENNUNG_PATTERN_END
)
export const EINDEUTIGE_KENNUNG_REGEXP = new RegExp(EINDEUTIGE_KENNUNG_PATTERN)
export const EINDEUTIGE_KENNUNG_MAX_LENGTH = 20

export const FREITEXT_LONG_REGEXP = FREITEXT_MULTILINE_REGEXP
export const FREITEXT_LONG_MAX_LENGTH = 4096

export const FREITEXT_SHORT_REGEXP = FREITEXT_ONELINE_REGEXP
export const FREITEXT_SHORT_MAX_LENGTH = 100

export const KM_SIGNAL_REGEXP = FREITEXT_ONELINE_REGEXP
export const KM_SIGNAL_MAX_LENGTH = 20

const KMH_PATTERN = String.raw`^\d*$`
export const KMH_REGEXP = new RegExp(KMH_PATTERN)
export const KMH_MAX_LENGTH = 3

export const UHRZEIT_REGEXP = FREITEXT_ONELINE_REGEXP
export const UHRZEIT_MAX_LENGTH = 10

export const ETCS_EINFAHRWEICHE_REGEXP = FREITEXT_ONELINE_REGEXP
export const ETCS_EINFAHRWEICHE_MAX_LENGTH = 15

// Befehlsnachrichten, Auftraege filter input rules
// SwRS_00444_S0_R
export const ZUGNUMMER_FILTER_REGEXP = ZUGNUMMER_REGEXP
export const ZUGNUMMER_FILTER_MAX_LENGTH = ZUGNUMMER_MAX_LENGTH

const FILTER_SHORT_REGEXP = FREITEXT_ONELINE_REGEXP
const FILTER_SHORT_MAX_LENGTH = 20
// SwRS_20759_S0_R
export const AUFTRAG_NAME_FILTER_REGEXP = FILTER_SHORT_REGEXP
export const AUFTRAG_NAME_FILTER_MAX_LENGTH = FILTER_SHORT_MAX_LENGTH
// SwRS_20590_S0_R
export const BEFEHL_FILTER_REGEXP = FILTER_SHORT_REGEXP
export const BEFEHL_FILTER_MAX_LENGTH = FILTER_SHORT_MAX_LENGTH
// SwRS_20624_S0_R
export const EINDEUTIGE_KENNUNG_FILTER_REGEXP = FILTER_SHORT_REGEXP
export const EINDEUTIGE_KENNUNG_FILTER_MAX_LENGTH = FILTER_SHORT_MAX_LENGTH
// SwRS_20628_S0_R, SwRS_20761_S0_R
export const NAME_FDL_FILTER_REGEXP = FREITEXT_ONELINE_REGEXP
export const NAME_FDL_FILTER_MAX_LENGTH = 40
